import React, { useEffect } from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { ApplicationState } from "../../../store";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
type MortgageQualificationCalculatorProps = RouteComponentProps<{}>;

const MortgageQualificationCalculator: React.FunctionComponent<MortgageQualificationCalculatorProps> = () => {
    const { t: tLang, i18n: i18nLang } = useTranslation();

    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    function handleSubmit(e: any) {
        e.preventDefault();
        e.stopPropagation();
    }

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12">
                    <h1 className="title-page">{tLang("resourcesSection.calculator.label.mortgageQualificationCalculator")} </h1>
                </div>
            </div>

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="table-container scroll">
                            <div id="calc-body">
                                <div id="container_outer">
                                    <div>
                                        <Link id="close" to="/resources/calculators">
                                            X
                                        </Link>
                                    </div>

                                    <div className="calc_container">
                                        <div className="calc_contents">
                                            <div className="calc_description">
                                                <h3 className="financial" style={{ paddingBottom: "20px", paddingTop: "20px" }}>
                                                    Mortgage Qualification Calculator
                                                </h3>
                                                <p>
                                                    <strong>This calculator will help you to determine how much house you can afford and/or qualify for.</strong>
                                                </p>
                                                <p>
                                                    Complete or change the entry fields in the "Input" column of all three sections. The calculator will
                                                    automatically recalculate anytime you press the Tab key after making a change to an input field.
                                                </p>
                                            </div>

                                            <form name="mortCalc" onSubmit={(e) => handleSubmit(e)}>
                                                <table className="calculator mort">
                                                    <tbody>
                                                        <tr>
                                                            <th>
                                                                <strong>Purchase Information</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Inputs</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Outputs</strong>
                                                            </th>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="purchaseAmt"><strong>Purchase price:</strong></label></td>
                                                            <td>
                                                                <strong>Purchase price:</strong>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="TEXT"
                                                                    name="purchaseAmt"
                                                                    id="purchaseAmt"
                                                                    aria-labelledby="purchaseAmt"
                                                                    size={15}
                                                                    defaultValue="60000"
                                                                    onChange={(e) => window.computeForm(e)}
                                                                />
                                                            </td>
                                                            <td>&nbsp;</td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="downPayMethod"><strong>Down payment:</strong></label></td>
                                                            <td>
                                                                <strong id="downPayPercAmtLabel">Down payment: &nbsp;</strong>
                                                            </td>
                                                            <td>
                                                                <div style={{ display: "flex" }}>
                                                                    <select
                                                                        name="downPayMethod"
                                                                        id="downPayMethod"
                                                                        size={1}
                                                                        onChange={(e) => window.computeForm(e)}
                                                                        style={{ width: "3em" }}
                                                                        defaultValue="0"
                                                                    >
                                                                        <option value="0">%</option>
                                                                        <option value="1">$</option>
                                                                    </select>
                                                                    <input
                                                                        type="TEXT"
                                                                        name="downPayPercAmt"
                                                                        id="downPayPercAmt"
                                                                        aria-labelledby="downPayPercAmtLabel"
                                                                        size={6}
                                                                        defaultValue="10"
                                                                        onChange={(e) => window.computeForm(e)}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label htmlFor="downPayAmt" className="hide-label"><strong>Down payment: &nbsp; &nbsp;</strong></label>
                                                                <input type="TEXT" name="downPayAmt" id="downPayAmt" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="loanAmt"><strong>Loan amount:</strong></label></td>
                                                            <td>&nbsp;</td>
                                                            <td>
                                                                <input type="TEXT" name="loanAmt" id="loanAmt" aria-labelledby="loanAmt" />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="intRate"><strong>Annual interest rate:</strong></label></td>
                                                            <td>
                                                                <strong>Annual interest rate:</strong>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="TEXT"
                                                                    name="intRate"
                                                                    id="intRate"
                                                                    aria-labelledby="intRate"
                                                                    defaultValue="8"
                                                                    onChange={(e) => window.computeForm(e)}
                                                                />
                                                            </td>
                                                            <td>&nbsp;</td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="noYears"><strong>Length of the mortgage in years:</strong></label></td>
                                                            <td>
                                                                <strong>Length of the mortgage in years:</strong>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="TEXT"
                                                                    name="noYears"
                                                                    id="noYears"
                                                                    aria-labelledby="noYears"
                                                                    defaultValue="30"
                                                                    onChange={(e) => window.computeForm(e)}
                                                                />
                                                            </td>
                                                            <td>&nbsp;</td>
                                                        </tr>

                                                        <tr>
                                                            <th className="calc_divider">
                                                                <strong>Payment Information</strong>
                                                            </th>
                                                            <th className="calc_divider">
                                                                <strong>Inputs</strong>
                                                            </th>
                                                            <th className="calc_divider">
                                                                <strong>Outputs (Monthly)</strong>
                                                            </th>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="pmtPI"><strong>Monthly principal &amp; interest payment:</strong></label></td>
                                                            <td>&nbsp;</td>
                                                            <td>
                                                                <input type="TEXT" name="pmtPI" id="pmtPI" aria-labelledby="pmtPI" />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="propTaxMethod"><strong>Annual property taxes:</strong></label></td>
                                                            <td>
                                                                <strong>Annual property taxes: &nbsp;</strong>
                                                            </td>
                                                            <td>
                                                                <div style={{ display: "flex" }}>
                                                                    <select
                                                                        name="propTaxMethod"
                                                                        id="propTaxMethod"
                                                                        size={1}
                                                                        onChange={(e) => window.computeForm(e)}
                                                                        style={{ width: "3em" }}
                                                                        defaultValue="1"
                                                                    >
                                                                        <option value="0">%</option>
                                                                        <option value="1">$</option>
                                                                    </select>
                                                                    <label htmlFor="propTaxPercAmt" className="hide-label"><strong>Annual property taxes: &nbsp; &nbsp;</strong></label>
                                                                    <input
                                                                        type="TEXT"
                                                                        name="propTaxPercAmt"
                                                                        id="propTaxPercAmt"
                                                                        defaultValue="1020"
                                                                        onChange={(e) => window.computeForm(e)}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label htmlFor="propTaxAmt" className="hide-label"><strong>Annual property taxes: &nbsp; &nbsp; &nbsp;</strong></label>
                                                                <input type="TEXT" name="propTaxAmt" id="propTaxAmt" />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="insMethod"><strong>Annual insurance:</strong></label></td>
                                                            <td>
                                                                <div style={{ display: "flex" }}>
                                                                    <select
                                                                        name="insMethod"
                                                                        id="insMethod"
                                                                        size={1}
                                                                        onChange={(e) => window.computeForm(e)}
                                                                        style={{ width: "3em" }}
                                                                        defaultValue="1"
                                                                    >
                                                                        <option value="0">%</option>
                                                                        <option value="1">$</option>
                                                                    </select>
                                                                    <label htmlFor="insPercAmt" className="hide-label"><strong>Annual insurance: &nbsp;</strong></label>
                                                                    <input
                                                                        type="TEXT"
                                                                        name="insPercAmt"
                                                                        id="insPercAmt"
                                                                        size={6}
                                                                        defaultValue="300"
                                                                        onChange={(e) => window.computeForm(e)}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label htmlFor="insAmt" className="hide-label"><strong>Annual insurance: &nbsp; &nbsp;</strong></label>
                                                                <input type="TEXT" name="insAmt" id="insAmt" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="pmiMethod"><strong>Annual PMI:</strong></label></td>
                                                            <td>
                                                                <div style={{ display: "flex" }}>
                                                                    <select
                                                                        name="pmiMethod"
                                                                        id="pmiMethod"
                                                                        aria-labelledby="pmiMethod"
                                                                        size={1}
                                                                        onChange={(e) => window.computeForm(e)}
                                                                        style={{ width: "3em" }}
                                                                        defaultValue="0"
                                                                    >
                                                                        <option value="0">%</option>
                                                                        <option value="1">$</option>
                                                                    </select>
                                                                    <label htmlFor="pmiPercAmt" className="hide-label"><strong>Annual PMI: &nbsp;</strong></label>
                                                                    <input
                                                                        type="TEXT"
                                                                        name="pmiPercAmt"
                                                                        id="pmiPercAmt"
                                                                        size={6}
                                                                        defaultValue=".5"
                                                                        onChange={(e) => window.computeForm(e)}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label htmlFor="pmiAmt" className="hide-label"><strong>Annual PMI: &nbsp; &nbsp;</strong></label>
                                                                <input type="TEXT" name="pmiAmt" id="pmiAmt" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="assocAmt"><strong>Monthly association fees:</strong></label></td>
                                                            <td>
                                                                <input
                                                                    type="TEXT"
                                                                    name="assocAmt"
                                                                    id="assocAmt"
                                                                    aria-labelledby="assocAmt"
                                                                    size={15}
                                                                    onChange={(e) => window.computeForm(e)}
                                                                />
                                                            </td>
                                                            <td>&nbsp;</td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="pmtPITI"><strong>Monthly payment (PITI):</strong></label></td>
                                                            <td>&nbsp;</td>
                                                            <td>
                                                                <input type="TEXT" name="pmtPITI" id="pmtPITI" aria-labelledby="pmtPITI" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="deductAmt"><strong>Tax deductible portion of payment:</strong></label></td>
                                                            <td>&nbsp;</td>
                                                            <td>
                                                                <input type="TEXT" name="deductAmt" id="deductAmt" aria-labelledby="deductAmt" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th className="calc_divider">
                                                                <strong>Qualifying Information</strong>
                                                            </th>
                                                            <th className="calc_divider">
                                                                <strong>Inputs</strong>
                                                            </th>
                                                            <th className="calc_divider">
                                                                <strong>Outputs</strong>
                                                            </th>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <label htmlFor="grossPay" > <strong>Gross income :&nbsp;
							                                        <select name="payMethod" id="payMethod" aria-labelledby="payMethod" size={1} onChange={(e) => window.computeForm(e)} style={{ width: "8em", height: "2em" }} defaultValue="0">
                                                                        <option value="0">Annually
							                                            </option><option value="1">Monthly
							                                            </option></select>
                                                                </strong></label>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="TEXT"
                                                                    name="grossPay"
                                                                    id="grossPay"
                                                                    aria-labelledby="grossPay"
                                                                    size={15}
                                                                    defaultValue="40000"
                                                                    onChange={(e) => window.computeForm(e)}
                                                                />
                                                            </td>
                                                            <td>&nbsp;</td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="moDebts"><strong>Monthly debt payments:</strong></label></td>
                                                            <td>
                                                                <input
                                                                    type="TEXT"
                                                                    name="moDebts"
                                                                    id="moDebts"
                                                                    aria-labelledby="moDebts"
                                                                    size={15}
                                                                    onChange={(e) => window.computeForm(e)}
                                                                />
                                                            </td>
                                                            <td>&nbsp;</td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="qualifyYN"><strong>Qualify for loan?:</strong></label></td>
                                                            <td>&nbsp;</td>
                                                            <td>
                                                                <input type="TEXT" name="qualifyYN" id="qualifyYN" aria-labelledby="qualifyYN" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="qualifyMax"><strong>Maximum qualifying loan amount:</strong></label></td>
                                                            <td>&nbsp;</td>
                                                            <td>
                                                                <input type="TEXT" name="qualifyMax" id="qualifyMax" aria-labelledby="qualifyMax" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="ratioIncome"><strong>Current Income to payment ratio (max = 28%):</strong></label></td>
                                                            <td>&nbsp;</td>
                                                            <td>
                                                                <input type="TEXT" name="ratioIncome" id="ratioIncome" aria-labelledby="ratioIncome" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td ><label htmlFor="ratioDebt"><strong>Current debt to income ratio (max = 36%):</strong></label></td>
                                                            <td>&nbsp;</td>
                                                            <td>
                                                                <input type="TEXT" name="ratioDebt" id="ratioDebt" aria-labelledby="ratioDebt" size={15} />
                                                            </td>
                                                        </tr>

                                                        <tr className="calc_divider">
                                                            <td colSpan={2}></td>
                                                            <td style={{ float: "right" }}>
                                                                <input
                                                                    className="debt_textbtn"
                                                                    type="submit"
                                                                    value="Calculate"
                                                                    onClick={(e) => window.computeForm(e)}
                                                                    style={{ width: "65px" }}
                                                                />
                                                                &nbsp;
                                                                <input className="debt_textbtn" type="reset" value="Reset" style={{ width: "50px" }} />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td colSpan={3}>
                                                                <input
                                                                    className="debt_textbtn"
                                                                    type="button"
                                                                    value="Create Amortization Schedule"
                                                                    onClick={(e) => window.createReport(e)}
                                                                    style={{ width: "214px", float: "right" }}
                                                                />
                                                                <br />

                                                                <span style={{ float: "right" }}>
                                                                    Longer term loans may take a few moments for the report to be generated.
                                                                </span>
                                                                <input type="HIDDEN" name="HmoPmt" value="0" readOnly />
                                                                <input type="HIDDEN" name="Hprincipal" value="0" readOnly />
                                                                <input type="HIDDEN" name="HaNPer" value="0" readOnly />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={4}>&nbsp;</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Helmet>
                <script src="js/MortgageQualificationCalculator.js" type="text/javascript" />
            </Helmet>
        </React.Fragment>
    );
};
export default MortgageQualificationCalculator;
